import React, { useEffect, useState } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { FileTextIcon } from 'lucide-react';
import { getAuditLogs, AuditLog } from '../../utils/auditLog';
import UnifiedTransactionTable from '../shared/UnifiedTransactionTable';
const AuditLogPage: React.FC = () => {
  const [auditLogs, setAuditLogs] = useState<AuditLog[]>([]);
  const [flattenedLogs, setFlattenedLogs] = useState<any[]>([]);
  useEffect(() => {
    loadAuditLogs();
    const interval = setInterval(loadAuditLogs, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    // Flatten audit logs for table display
    const flattened = auditLogs.flatMap(log => log.changes.map((change, index) => ({
      id: `${log.id}-${index}`,
      timestamp: log.timestamp,
      userId: log.userId,
      eventType: log.eventType,
      source: log.source,
      fieldName: change.fieldName,
      oldValue: change.oldValue || '-',
      newValue: change.newValue || '-'
    })));
    setFlattenedLogs(flattened);
  }, [auditLogs]);
  const loadAuditLogs = () => {
    const logs = getAuditLogs();
    setAuditLogs(logs);
  };
  const handleViewDetails = (log: any) => {
    console.log('View audit log:', log);
  };
  const getEventTypeColor = (eventType: string) => {
    switch (eventType) {
      case 'Create':
        return 'success';
      case 'Edit':
        return 'primary';
      case 'Sync':
        return 'info';
      case 'Status Change':
        return 'warning';
      default:
        return 'default';
    }
  };
  const getSourceColor = (source: string) => {
    switch (source) {
      case 'BO_USER':
        return 'primary';
      case 'BANK_API':
        return 'secondary';
      case 'SYSTEM':
        return 'default';
      default:
        return 'default';
    }
  };
  const columns = [{
    id: 'timestamp',
    label: 'Timestamp',
    filterable: true,
    filterType: 'date' as const,
    format: (value: string) => new Date(value).toLocaleString()
  }, {
    id: 'userId',
    label: 'User ID',
    filterable: true,
    filterType: 'text' as const
  }, {
    id: 'eventType',
    label: 'Event Type',
    filterable: true,
    filterType: 'select' as const,
    filterOptions: ['Create', 'Edit', 'Sync', 'Status Change'],
    format: (value: string) => <Chip label={value} size="small" color={getEventTypeColor(value) as any} data-id="element-60" />
  }, {
    id: 'source',
    label: 'Source',
    filterable: true,
    filterType: 'select' as const,
    filterOptions: ['BO_USER', 'BANK_API', 'SYSTEM'],
    format: (value: string) => <Chip label={value} size="small" color={getSourceColor(value) as any} data-id="element-61" />
  }, {
    id: 'fieldName',
    label: 'Field Name',
    filterable: true,
    filterType: 'text' as const
  }, {
    id: 'oldValue',
    label: 'Old Value',
    filterable: true,
    filterType: 'text' as const
  }, {
    id: 'newValue',
    label: 'New Value',
    filterable: true,
    filterType: 'text' as const
  }];
  return <Box sx={{
    p: 3
  }} data-id="element-62">
      <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      mb: 3
    }} data-id="element-63">
        <FileTextIcon size={28} color="#0052CC" data-id="element-64" />
        <Typography variant="h4" sx={{
        fontWeight: 700,
        color: '#0052CC'
      }} data-id="element-65">
          Audit Log
        </Typography>
      </Box>

      <UnifiedTransactionTable columns={columns} data={flattenedLogs} onViewDetails={handleViewDetails} title={`Audit Logs (${flattenedLogs.length})`} emptyMessage="No audit logs found" data-id="element-66" />
    </Box>;
};
export default AuditLogPage;